export const workList = [
    {
        description: 'workList.employed',
        label: 'workList.employed',
        type: 'workList',
        value: '1'
    },
    {
        description: 'workList.partTime',
        label: 'workList.partTime',
        type: 'workList',
        value: '2'
    },
    {
        description: 'workList.selfEmployed',
        label: 'workList.selfEmployed',
        type: 'workList',
        value: '3'
    },
    {
        description: 'workList.retired',
        label: 'workList.retired',
        type: 'workList',
        value: '4'
    },
    {
        description: 'workList.student',
        label: 'workList.student',
        type: 'workList',
        value: '5'
    },
    {
        description: 'workList.unemployed',
        label: 'workList.unemployed',
        type: 'workList',
        value: '6'
    }
];

export default workList;